import React, { useCallback, useEffect, useState } from "react";
import { pedidoBackend } from "../../registro/registro";
import {
  Aviso,
  Boton,
  FilaConfig,
  Panel,
  Tabla,
  TablaWrapper,
  Vacio,
} from "./panelStyles";

// Configuración de la alerta, que maneja IT desde el panel: qué vendedor instala
// sus propias ventas y a qué mails llega el aviso. Quién entra al panel es una
// lista fija en el backend (acá solo se muestra).

const mensajeError = (e) => e?.response?.data?.error || e?.message || "No se pudo guardar";

const Seccion = ({ titulo, descripcion, children }) => (
  <Panel>
    <h2 style={{ margin: 0, fontSize: "1.05rem", color: "var(--violetaOscuro)" }}>{titulo}</h2>
    <Aviso>{descripcion}</Aviso>
    {children}
  </Panel>
);

const ConfiguracionPanel = () => {
  const [vendedores, setVendedores] = useState([]);
  const [admins, setAdmins] = useState([]);
  const [conocidos, setConocidos] = useState([]);
  const [mensaje, setMensaje] = useState(null);
  const [ocupado, setOcupado] = useState(false);

  const vendedorVacio = { usuario: "", nombre: "", mails: "" };
  const [nuevoVendedor, setNuevoVendedor] = useState(vendedorVacio);
  // El usuario se elige de un desplegable (usuarios que ya entraron a la web).
  // "manual" permite tipearlo a mano para alguien que todavía no entró.
  const [manual, setManual] = useState(false);

  const cargar = useCallback(async () => {
    try {
      const [v, a, u] = await Promise.all([
        pedidoBackend("get", "/panel/vendedores-instaladores"),
        pedidoBackend("get", "/panel/roles"),
        pedidoBackend("get", "/panel/usuarios-conocidos"),
      ]);
      setVendedores(v.data.data || []);
      setAdmins(a.data.data || []);
      setConocidos(u.data.data || []);
    } catch (e) {
      setMensaje({ texto: mensajeError(e), error: true });
    }
  }, []);

  useEffect(() => {
    cargar();
  }, [cargar]);

  const accion = async (fn, textoOk) => {
    setOcupado(true);
    setMensaje(null);
    try {
      await fn();
      setMensaje({ texto: textoOk, error: false });
      await cargar();
    } catch (e) {
      setMensaje({ texto: mensajeError(e), error: true });
    } finally {
      setOcupado(false);
    }
  };

  // Al elegir un usuario del desplegable, se autocompleta nombre y promotor con
  // lo que ya sabemos de su login (editable). "Otro" habilita la carga a mano.
  const elegirUsuario = (val) => {
    if (val === "__manual__") {
      setManual(true);
      setNuevoVendedor((v) => ({ ...v, usuario: "" }));
      return;
    }
    setManual(false);
    const u = conocidos.find((x) => x.usuario === val);
    setNuevoVendedor((v) => ({ ...v, usuario: val, nombre: u?.promotorNombre || v.nombre }));
  };

  return (
    <>
      {mensaje && (
        <Panel>
          <Aviso $error={mensaje.error}>{mensaje.texto}</Aviso>
        </Panel>
      )}

      <Seccion
        titulo="Vendedores que instalan sus propias ventas"
        descripcion="Cada alta que carguen dispara un aviso por mail para asignarles la instalación a ellos y no a otra cuadrilla. Se los reconoce por el usuario de login (el promotor ya viene de SIGA). El aviso va a los mails de cada vendedor: uno o varios, separados por coma."
      >
        <TablaWrapper>
          <Tabla $min="620px">
            <thead>
              <tr>
                <th>Usuario</th>
                <th>Nombre</th>
                <th>Mails de aviso</th>
                <th> </th>
              </tr>
            </thead>
            <tbody>
              {vendedores.length === 0 && (
                <tr>
                  <Vacio colSpan={4}>Todavía no hay ninguno configurado.</Vacio>
                </tr>
              )}
              {vendedores.map((v) => (
                <tr key={v.usuario}>
                  <td>{v.usuario}</td>
                  <td>{v.nombre}</td>
                  <td>{v.mails || "—"}</td>
                  <td>
                    <Boton
                      type="button"
                      $secundario
                      disabled={ocupado}
                      onClick={() =>
                        accion(
                          () =>
                            pedidoBackend(
                              "delete",
                              `/panel/vendedores-instaladores/${encodeURIComponent(v.usuario)}`,
                            ),
                          `Vendedor ${v.usuario} eliminado.`,
                        )
                      }
                    >
                      Quitar
                    </Boton>
                  </td>
                </tr>
              ))}
            </tbody>
          </Tabla>
        </TablaWrapper>

        <FilaConfig
          onSubmit={(e) => {
            e.preventDefault();
            if (!nuevoVendedor.usuario.trim()) {
              setMensaje({ texto: "Elegí un usuario (o cargalo a mano).", error: true });
              return;
            }
            accion(
              () =>
                pedidoBackend("post", "/panel/vendedores-instaladores", {
                  datos: {
                    usuario: nuevoVendedor.usuario.trim(),
                    nombre: nuevoVendedor.nombre.trim(),
                    mails: nuevoVendedor.mails.trim(),
                  },
                }),
              "Vendedor guardado.",
            ).then(() => {
              setNuevoVendedor(vendedorVacio);
              setManual(false);
            });
          }}
        >
          {conocidos.length === 0 ? (
            <input
              required
              placeholder="usuario de login"
              value={nuevoVendedor.usuario}
              onChange={(e) => setNuevoVendedor((v) => ({ ...v, usuario: e.target.value }))}
            />
          ) : (
            <>
              <select value={manual ? "__manual__" : nuevoVendedor.usuario} onChange={(e) => elegirUsuario(e.target.value)}>
                <option value="">Elegí un usuario…</option>
                {conocidos.map((u) => (
                  <option key={u.usuario} value={u.usuario}>
                    {u.promotorNombre ? `${u.promotorNombre} (${u.usuario})` : u.usuario}
                  </option>
                ))}
                <option value="__manual__">Otro (escribir a mano)…</option>
              </select>
              {manual && (
                <input
                  required
                  placeholder="usuario de login"
                  value={nuevoVendedor.usuario}
                  onChange={(e) => setNuevoVendedor((v) => ({ ...v, usuario: e.target.value }))}
                />
              )}
            </>
          )}
          <input
            required
            placeholder="nombre y apellido"
            value={nuevoVendedor.nombre}
            onChange={(e) => setNuevoVendedor((v) => ({ ...v, nombre: e.target.value }))}
          />
          <input
            required
            placeholder="mail(s) de aviso (separados por coma)"
            value={nuevoVendedor.mails}
            onChange={(e) => setNuevoVendedor((v) => ({ ...v, mails: e.target.value }))}
          />
          <Boton type="submit" disabled={ocupado}>
            Agregar
          </Boton>
        </FilaConfig>
      </Seccion>

      <Seccion
        titulo="Quién entra al panel"
        descripcion="Lista fija, definida por Sistemas. Para agregar o quitar a alguien hay que pedirlo: se cambia en el backend. El mail es adonde le llega el reporte cuando lo pide."
      >
        <TablaWrapper>
          <Tabla $min="420px">
            <thead>
              <tr>
                <th>Usuario</th>
                <th>Mail</th>
              </tr>
            </thead>
            <tbody>
              {admins.map((a) => (
                <tr key={a.usuario}>
                  <td>{a.usuario}</td>
                  <td>{a.email}</td>
                </tr>
              ))}
            </tbody>
          </Tabla>
        </TablaWrapper>
      </Seccion>
    </>
  );
};

export default ConfiguracionPanel;
